module.exports = __webpack_public_path__ + "static/media/csb.8036deac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/csb.jpg
// module id = 97
// module chunks = 0